import React, { ReactElement } from 'react';
import { FeatureFlagWrapper } from '@app/components/FeatureFlagWrapper';
import { useConfig } from '@app/config';
import { SourceDetailsSelector } from '@app/screens/router-intent/components/SourceDetailsSelector';
import { TargetDetailsSelector } from '@app/screens/router-intent/components/TargetDetailsSelector';
import { SubmitRouting } from '@app/screens/router-intent/components/SubmitRouting';
import { Grid, VStack } from '@chakra-ui/react';
import { DepositLiquidityProgress } from '@app/screens/router-intent/components/DepositLiquidityProgress';
import { useDepositLiquidity } from '@app/hooks/router-intent/useDepositLiquidity';
import AddLiquidityLayout from '@app/layouts/AddLiquidityLayout/AddLiquidityLayout';
import { NextPageWithLayout } from '@app/pages/_app';

const AddLiquidityRouterPage: NextPageWithLayout = () => {
  const config = useConfig();

  const {
    isLoading,
    errors,
    isAvailable,
    depositLiquidity,
    details,
    txResult
  } = useDepositLiquidity();

  return (
    <FeatureFlagWrapper show={!!config?.FLAGS.showRouterIntentPage || true}>
      <Grid
        gridTemplateColumns={['1fr', '1fr', '1fr', '1fr 1.6fr']}
        p={0}
        w="100%"
        gap={6}
      >
        <VStack mx="auto" mt={[4, 16]} w="100%" gap={6} alignItems="flex-start">
          <SourceDetailsSelector />
          <TargetDetailsSelector />
          <SubmitRouting
            isAvailable={isAvailable}
            isLoading={isLoading}
            details={details}
            errors={errors}
            depositLiquidity={depositLiquidity}
          />
        </VStack>
        <VStack mx="auto" mt={[4, 16]} w="100%" gap={6} alignItems="flex-start">
          <DepositLiquidityProgress
            isAvailable={isAvailable}
            isLoading={isLoading}
            details={details}
            txResult={txResult}
          />
        </VStack>
      </Grid>
    </FeatureFlagWrapper>
  );
};

AddLiquidityRouterPage.getLayout = function getLayout(page: ReactElement) {
  return <AddLiquidityLayout>{page}</AddLiquidityLayout>;
};

export default AddLiquidityRouterPage;
